/* Silumen : sélecteur Couleur d'éclairage compact (snippets/silumen-cct-picker.liquid) */
(function () {
  if (window.slCctPicker) return;
  window.slCctPicker = true;

  function sync(root) {
    if (!root) return;
    var input = root.querySelector('.sl-cct__grid input:checked');
    var current = root.querySelector('[data-sl-cct-current]');
    if (input && current) current.textContent = input.value;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-sl-cct] input[data-variant-input]')) {
      sync(t.closest('[data-sl-cct]'));
    }
  });

  document.addEventListener('variant:change', function () {
    document.querySelectorAll('[data-sl-cct]').forEach(sync);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if ((e.key === 'Enter' || e.key === ' ') && t && t.classList && t.classList.contains('sl-cct__tile')) {
      e.preventDefault();
      t.click();
    }
  });
})();